import React from "react";
import { Route } from "react-router-dom";
import { ClientApiProps } from "../common/ClientApiProps";
import { Layout } from "../pages";
import { getApiClient } from "../api";

export const getNoSidebarRoutes = (props: ClientApiProps) => {
  return (
    <>
      <Route
        path="/senderid/*"
        element={
          <></>
        }
      />
    </>
  );
}

export const renderAppRoutes = (props: ClientApiProps) => {
  return (
    <>
      <Route
        path="/senderid/*"
        element={
          <Layout {...props} />
        }
      />
    </>
  );
};

export const getAppNavigation = async (props: ClientApiProps) => {
  try {
    const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);
    var access = await client.getAccess();
    return access ? [{ order: 50, url: '/senderid', title: 'Sender ID registry', description: 'Manage SMS alpha tags and confirmations to use.' }] : []
  }
  catch(e) {
    return [];
  }
};
